// src/pages/admin/Education/ViewScholarship.jsx
import React from 'react';
import {
  FaTag,
  FaBuilding,
  FaMoneyBillWave,
  FaCalendarAlt,
  FaGlobe,
  FaEnvelope,
  FaPhone,
  FaMapMarkerAlt,
  FaCheckCircle,
  FaStar,
  FaClock,
  FaEye,
  FaUsers,
} from 'react-icons/fa';

function ViewScholarship({ data }) {
  if (!data) {
    return <div className="text-center py-4">No data available</div>;
  }

  const formatDate = (date) => {
    if (!date) return 'N/A';
    return new Date(date).toLocaleString('en-US', {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
    });
  };

  const getStatusBadge = (status) => {
    const statusMap = {
      'pending': { class: 'badge bg-warning', label: 'Pending' },
      'approved': { class: 'badge bg-success', label: 'Approved' },
      'rejected': { class: 'badge bg-danger', label: 'Rejected' },
      'expired': { class: 'badge bg-secondary', label: 'Expired' },
    };
    const statusInfo = statusMap[status] || statusMap['pending'];
    return <span className={statusInfo.class}>{statusInfo.label}</span>;
  };

  const getCategoryLabel = (category) => {
    const categoryMap = {
      'scholarship': 'Scholarship',
      'education_loan': 'Education Loan',
      'career_guidance': 'Career Guidance',
      'skill_development': 'Skill Development',
      'study_abroad': 'Study Abroad',
    };
    return categoryMap[category] || category || 'N/A';
  };

  const getTypeLabel = (type) => {
    const typeMap = {
      'government': 'Government',
      'private': 'Private',
      'trust': 'Trust',
      'corporate': 'Corporate',
      'international': 'International',
    };
    return typeMap[type] || type || 'N/A';
  };

  const displayFields = [
    { key: 'title', label: 'Title', icon: <FaTag /> },
    { key: 'category', label: 'Category', format: getCategoryLabel, icon: <FaTag /> },
    { key: 'type', label: 'Type', format: getTypeLabel, icon: <FaBuilding /> },
    { key: 'amount', label: 'Amount', icon: <FaMoneyBillWave /> },
    { key: 'deadline', label: 'Deadline', format: formatDate, icon: <FaCalendarAlt /> },
    { key: 'description', label: 'Description' },
    { key: 'eligibility_criteria', label: 'Eligibility Criteria' },
    { key: 'benefits', label: 'Benefits' },
    { key: 'documents_required', label: 'Documents Required' },
    { key: 'application_process', label: 'Application Process' },
    { key: 'website', label: 'Website', icon: <FaGlobe /> },
    { key: 'email', label: 'Email', icon: <FaEnvelope /> },
    { key: 'phone', label: 'Phone', icon: <FaPhone /> },
    { key: 'address', label: 'Address', icon: <FaMapMarkerAlt /> },
    { key: 'city', label: 'City', icon: <FaMapMarkerAlt /> },
    { key: 'state', label: 'State', icon: <FaMapMarkerAlt /> },
    { key: 'pincode', label: 'Pincode', icon: <FaMapMarkerAlt /> },
    { key: 'status', label: 'Status', format: getStatusBadge },
    { key: 'is_featured', label: 'Featured', format: (val) => val ? 'Yes' : 'No', icon: <FaStar /> },
    { key: 'is_verified', label: 'Verified', format: (val) => val ? 'Yes' : 'No', icon: <FaCheckCircle /> },
    { key: 'view_count', label: 'Views', icon: <FaEye /> },
    { key: 'application_count', label: 'Applications', icon: <FaUsers /> },
    { key: 'created_at', label: 'Created At', format: formatDate, icon: <FaClock /> },
    { key: 'updated_at', label: 'Updated At', format: formatDate, icon: <FaClock /> },
  ];

  const getValue = (field) => {
    let value = data[field.key];
    if (field.format) {
      value = field.format(value);
    }
    return value || 'N/A';
  };

  return (
    <div className="view-scholarship-container">
      {/* Badges */}
      <div className="text-center mb-3">
        {data.is_featured && (
          <span className="badge bg-warning text-dark me-2">
            <FaStar className="me-1" /> Featured
          </span>
        )}
        {data.is_verified && (
          <span className="badge bg-success">
            <FaCheckCircle className="me-1" /> Verified
          </span>
        )}
      </div>

      <div className="table-responsive">
        <table className="table table-bordered table-striped">
          <tbody>
            {displayFields.map((field) => (
              <tr key={field.key}>
                <th style={{ width: '30%', backgroundColor: '#f8f9fa' }}>
                  {field.icon && <span className="me-2">{field.icon}</span>}
                  {field.label}
                </th>
                <td>
                  {field.key === 'description' || field.key === 'eligibility_criteria' || 
                   field.key === 'benefits' || field.key === 'documents_required' || 
                   field.key === 'application_process' ? (
                    <div style={{ whiteSpace: 'pre-wrap', wordBreak: 'break-word' }}>
                      {getValue(field)}
                    </div>
                  ) : (
                    getValue(field)
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}

export default ViewScholarship;